import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import ContactParams from '../types/ContactParams';
import sendContact from '../api/sendContact';

import Header from '@/features/facility/welcome/components/Header';
import Footer from '@/features/facility/welcome/components/Footer';

const OtherContactMain: React.FC = () => {
  const { token } = useParams();
  const [inquiry, setInquiry] = useState<string>("")
  const [representativeName, setRepresentativeName] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([])
  const [isSubmitted, setSubmitted] = useState<boolean>(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const params: ContactParams = {
      token: token,
      inquiry: inquiry,
      representative_name: representativeName
    }

    try {
      await sendContact(params);
      setAlertMessageOpen(false);
      setSubmitted(true);
    } catch (err: any) {
      setAlertMessageOpen(true);
      setSubmitted(false);
      // err.responseが存在し、かつerr.response.dataが存在する場合
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        // 予期せぬエラーの場合の処理
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string) =>
    <li>{message}</li>
  );

  const form = (
    <main id="page-lens_order" className="wrapper">
      <section style={{ padding: '30px 0' }}>
        <div className="inner">
          <div className="sec-contact__item">
            <h1 className="c-ttl__01">お問い合わせ</h1>
            { alertMessageOpen &&
              <div className="contact-note mbpc-26 mbsp-24" style={{marginTop: '20px', marginBottom: '0px'}}>
                <ul>{ messages }</ul>
              </div>
            }
            <div className="contact-box">
              <div className="contact-box__left">
                <form onSubmit={handleSubmit}>
                  <div className="contact-box__form" id="id-01">
                    <h2 className="c-ttl__02 mbsp-13">シード オルソケラトロジー事業推進部</h2>
                    <p className="c-txt__01 contact-box__txt"> お問い合わせ電話番号：03-3813-1116<br /> 受付時間： 平日10:00～17:00<br /> メールにてお問い合わせの方は下記の項目をご入力の上、「送信する」ボタンを押してください。 </p>
                    <div className="contact-box__item">
                      <label className="contact-box__ttl">
                        <span>ご担当者様</span>
                        <small>必須</small>
                      </label>
                      <div className="contact-box__ct">
                        <input name="representative_name" type="text" className="input" onChange={ event => setRepresentativeName(event.target.value) } />
                      </div>
                    </div>
                    <div className="contact-box__item contact-box__item--start">
                      <label className="contact-box__ttl">
                        <span>お問い合わせ内容</span>
                        <small>必須</small>
                      </label>
                      <div className="contact-box__ct">
                        <textarea name="inquiry" className="input textarea" placeholder="お問い合わせ内容をご入力ください" onChange={ event => setInquiry(event.target.value) }></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="c-btn__01">送信する</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );

  const completed = (
    <main id="page-lens_order" className="wrapper">
      <section style={{ padding: '30px 0' }}>
        <div className="inner">
          <h1 className="c-ttl__01">お問い合わせメール送信完了</h1>
          <div className="sec-link" style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0', paddingRight: '0' }}>
            <p className="c-txt__01 c-al--c"><span>お問い合わせを受け付けました。</span></p>
            <a href="/facility/top" className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
          </div>
        </div>
      </section>
    </main>
  );

  return (
    <React.Fragment>
      <Header />
      { isSubmitted ? completed : form }
      <Footer />
    </React.Fragment>
  );
}

export default OtherContactMain;
